import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { ICompany } from "./types/_company";
import { ResponseData } from "./types/_public";
const api = new APIClient();

const path = "/companies";
const companyApi = {
  companies(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getCompany(
    id: string | number,
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICompany>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params);
  },

  postCompany(dataForm: any): Promise<AxiosResponse<ResponseData<ICompany>, any>> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putCompany(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<ICompany>, any>> {
    const url = `${path}/${id}`;
    return api.patch(url, dataForm);
  },

  deleteCompany(id: any) {
    return api.delete(`${path}/${id}`);
  },


};

export default companyApi;
